import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';
import {GenericFunctionsUtil} from '../utils/generic-functions.util';

@Directive({
  selector: '[siHighlight]'
})
export class HighlightDirective implements AfterViewInit {
  private _siHighlight: string;

  constructor(private element: ElementRef) {
  }

  get siHighlight() {
    return this._siHighlight;
  }

  @Input()
  set siHighlight(val) {
    this._siHighlight = val;
    setTimeout(() => {
      this.highlight(this.element);
    });
  }

  ngAfterViewInit() {
    this.highlight(this.element);
  }

  highlight(element: ElementRef): void {
    if (!this.siHighlight) {
      return;
    }

    const nativeElement = element.nativeElement ? element.nativeElement : element;
    if (nativeElement.children && nativeElement.children.length > 0) {
      for (let childElement of nativeElement.children) {
        this.highlight(childElement);
      }
    } else {
      let value = nativeElement.innerText.split('\n').join('');
      if (!value) {
        return;
      }

      const normalizedQuery = GenericFunctionsUtil.normalizeString(this.siHighlight.toLowerCase());
      let normalizedValue = GenericFunctionsUtil.normalizeString(value.toLowerCase());
      let startIndex = 0;
      let endIndex = 0;
      let htmlToBeReplaced = '';
      let nextString = '';
      do {
        value = value.substring(endIndex);
        normalizedValue = normalizedValue.substring(endIndex);
        startIndex = normalizedValue.indexOf(normalizedQuery);
        if (startIndex !== -1) {
          endIndex = startIndex + this.siHighlight.length;
          const previousString = value.substring(0, startIndex);
          const toBeReplaced = value.substring(startIndex, endIndex);
          nextString = value.substring(endIndex, value.length);
          htmlToBeReplaced += `${previousString}<span class="si-highligth-directive">${toBeReplaced}</span>`;
        } else if (htmlToBeReplaced !== '') {
          nativeElement.innerHTML = htmlToBeReplaced + nextString;
        }
      } while (startIndex !== -1);
    }
  }
}
